export const PAGE_TOP_DISCOUNT_BANNER_DOM_ID = "page-top-discount-banner";
